export default "__VITE_ASSET__$A1B7u8Y__"